import { ContentLayout, Header } from "@amzn/awsui-components-react";
import { FC } from "react";
import Layout from "../../../layout/Layout";

const ManageSprites: FC<any> = () => {
    return (
        <Layout>
            <ContentLayout header={<Header variant="h1">Sprites</Header>}>
                <>Sprites</>
            </ContentLayout>
        </Layout>
    )
}
export default ManageSprites;